import { useEffect, useState } from "react";
import { LogsTable } from "../../components/logs-table/LogsTable";
import { columns, getLogs, PAGE_SIZE } from "./viewModel";
import Pagination from "@/components/pagination/Pagination";



export const AdminLogs = () => {
   
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(1);

    const totalPages = Math.ceil(count / PAGE_SIZE);
    const [ dataArray, setDataArray ] = useState([]);
    const getData = async (page: number) => {
        const { data, count }  = await getLogs(page);
        setDataArray(data);
        setCount(count)
    }

    useEffect(() => {
        getData(page);
        window.scrollTo({top: 0, left: 0, behavior: "smooth"})
    }, [page])

    return <section className="admin-section">
        <h2>Historique</h2>
        <LogsTable columns={columns} dataArray={dataArray}></LogsTable>
        <Pagination page={page} totalPages={totalPages} onPageChange={setPage}></Pagination>
    </section>
};